/**
 * SCRUM-1032 QC round 2, item 3 — write the grid's staged edits before a bulk
 * configuration run reads the decoders.
 *
 * The run writes each decoder whole, from the copy it read when it opened. A
 * purpose still staged in the grid is not on that copy, so the run wrote the
 * old, empty purpose back over the one autosave had just stored. Flushing first
 * puts every edit on the server before the run reads it.
 *
 * Returns whether the run may go ahead: false when the save threw, or when rows
 * are still staged afterwards (a row that failed to write) — running then would
 * erase exactly those edits.
 */
export const flushBeforeApply = async ({
  save,
  hasPendingChanges,
}: {
  save: () => Promise<unknown>
  hasPendingChanges: () => boolean
}): Promise<boolean> => {
  try {
    await save()
  } catch {
    return false
  }
  return !hasPendingChanges()
}
